import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import FormDialog from './FormDialog'

const FormDialogContainer = (props) => {
  const handleOnSubmit = (...args) => {    
    props.onSubmit(...args).then(() => {
      setTimeout(props.onDone, 3000)
    })
  }

  return (
    <FormDialog
      config={props.config}
      area={props.area}
      onDone={props.onDone}
      onCancel={props.onCancel}
      themeColorHex={props.themeColorHex}
      onSubmit={handleOnSubmit}
      customValidation={props.customValidation}
      title={props.title}
      submitBtnLabel={props.submitBtnLabel}
      successMessage={props.successMessage}
      itemId={props.itemId}
      ctaClass={props.ctaClass}
      form={props.form}
      initialValues={props.initialValues}>
      {props.children}
    </FormDialog>
  )
}

FormDialogContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  themeColorHex: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  customValidation: PropTypes.func,
  title: PropTypes.string,
  submitBtnLabel: PropTypes.string,
  successMessage: PropTypes.string,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.object
}

function mapStateToProps(state) {
  return {
    themeColorHex: state.campaign.themeColorHex
  }
}

export default connect(mapStateToProps, null)(FormDialogContainer)